import ReactImageFn from 'react-image';

export const ReactImage = ReactImageFn;
